import { FC, useRef } from 'react';
import { Outlet } from 'react-router';
import cx from 'classnames';

import { HeaderWithNavigation } from '@legacy/components/layout/Header/Header';
import AppShell from '@legacy/components/layout/AppShell';

import styles from './LayoutPage.module.scss';

import { useIframeEvent } from './layoutPageHookHelper';
import { useHasNewNavigation } from '@/hooks/featureFlags';

interface LayoutPageProps {
  title?: string;
  hasCustomTable?: boolean;
}

export const LayoutPage: FC<LayoutPageProps> = ({
  title,
  hasCustomTable = false,
  ...props
}) => {
  const mainContentRef = useRef<HTMLDivElement>(null);

  const hasNewNavigation = useHasNewNavigation();

  useIframeEvent();

  return (
    <AppShell title={title} mainRefElement={mainContentRef}>
      {!hasNewNavigation ? <HeaderWithNavigation /> : null}

      <main
        ref={mainContentRef}
        className={cx(
          styles.Content,
          {
            [styles.HasCustomTable]: hasCustomTable,
            [styles.HasNewNavigation]: hasNewNavigation,
          },
          // The theme should be set on the content as other content is global = pink
        )}
        data-automation-id="LayoutPageMainContainer"
        {...props}
      >
        {/* An <Outlet> renders whatever child route is currently active,
          so you can think about this <Outlet> as a placeholder for
          the child routes we defined above. */}
        <Outlet />
      </main>
    </AppShell>
  );
};
